<template>
    <div class="container">
        <div v-if="!loading">
            <Title text="In attesa di verifica" />
            <div class="subtitile">
                <p>
                    Per poter accedere al sito il tuo account dovrà essere verificato da uno degli amministratori.
                </p>
            </div>
            <div class="button-container" @click="checkStatus()">
                <ButtonPrimary text="Ricarica la pagina"/>
            </div>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue';
import ButtonPrimary from '@/components/Button-Primary.vue';
import { mixins } from "@/mixins";

export default {
    name: 'NuovoUtente',
    data () {
        return {
            loading: false
        }
    },
    mixins: [mixins],
    components: {
        Title,
        ButtonPrimary
    },
    methods: {
        checkStatus: function(){
            this.$axios
            .get(this.$apibase + '/api/users/is_user_studio/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token'),
                }
            })
            .then((verified) => {
                if (verified.data.verified){
                  let user = {
                    'full_name': verified.data.fullname,
                    'user_type': verified.data.group,
                    'is_verified': verified.data.verified
                  }
                  this.$store.dispatch("setUser", user);
                  this.$router.push("/dashboard")
                }
                else {
                  this.$store.dispatch('setAlert', {message: "Il tuo account non è ancora stato verificato.", type: 'danger'});
                }
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        }
    }


}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
        color: #707070;
        text-align: left;
    }
    .subtitile {
        padding-top: 30px;
    }
    .button-container{
        margin-top: 50px;
        width: 50%;
        max-width: 200px;
    }
</style>